import { Component, effect, inject, input, ChangeDetectionStrategy } from '@angular/core';
import {
  MatTableDataSource,
  MatTable,
  MatColumnDef,
  MatHeaderCellDef,
  MatHeaderCell,
  MatCellDef,
  MatCell,
  MatHeaderRowDef,
  MatHeaderRow,
  MatRowDef,
  MatRow,
} from '@angular/material/table';
import { WorkingTimeCategory } from 'src/app/models/working_time_category.model';
import { ApiService } from 'src/app/services';
import { take } from 'rxjs';

@Component({
  selector: 'app-absence-categories-legend',
  templateUrl: './absence-categories-legend.component.html',
  styleUrl: './absence-categories-legend.component.css',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow],
})
export class AbsenceCategoriesLegendComponent {
  categoryId = input<number>();

  private _api = inject(ApiService);
  dataSource = new MatTableDataSource<WorkingTimeCategory>([]);
  displayedColumns: string[] = [
    'name',
    'days_allowed',
    'days_allowed_type',
    'is_paid',
    'all_day',
    'requires_justification',
    'must_be_compensated',
  ];

  constructor() {
    effect(() => {
      this._loadCategories();
    });
  }

  private _loadCategories(): void {
    const params: Record<string, string | number | boolean> = {
      is_working_time: false,
      with: 'active_legal_workers_agreement_working_time_category',
    };

    const categoryId = this.categoryId();

    // If categoryId is provided, filter by that id in the API call
    if (categoryId) {
      params['id'] = categoryId;
    }

    this._api
      .getAllAbsenceRequestWorkingTimeCategories(params)
      .pipe(take(1))
      .subscribe(categories => {
        this.dataSource.data = categories;
      });
  }

  getDaysAllowed(category: WorkingTimeCategory): string {
    const days = category.active_legal_workers_agreement_working_time_category?.days_allowed;
    return days !== undefined && days !== null ? days.toString() : '♾️';
  }

  getDaysAllowedType(category: WorkingTimeCategory): string {
    const type = category.active_legal_workers_agreement_working_time_category?.days_allowed_type;
    if (!type) return '-';

    const typeMap: Record<string, string> = {
      calendar_days: 'Días naturales',
      working_days: 'Días laborables',
      business_days: 'Días hábiles',
    };

    return typeMap[type] || type;
  }

  getIsPaid(category: WorkingTimeCategory): string {
    const isPaid = category.active_legal_workers_agreement_working_time_category?.is_paid;
    return isPaid !== undefined && isPaid !== null ? (isPaid ? 'Sí' : 'No') : '-';
  }

  getAllDay(category: WorkingTimeCategory): string {
    const allDay = category.active_legal_workers_agreement_working_time_category?.all_day;
    return allDay !== undefined && allDay !== null ? (allDay ? 'Sí' : 'No') : '-';
  }

  getRequiresJustification(category: WorkingTimeCategory): string {
    const requires = category.active_legal_workers_agreement_working_time_category?.requires_justification;
    if (!requires) return '-';

    const justificationMap: Record<string, string> = {
      no: 'No',
      optional: 'Opcional',
      required: 'Requerida',
    };

    return justificationMap[requires] || requires;
  }

  getMustBeCompensated(category: WorkingTimeCategory): string {
    const mustBeCompensated = category.active_legal_workers_agreement_working_time_category?.must_be_compensated;
    return mustBeCompensated !== undefined && mustBeCompensated !== null ? (mustBeCompensated ? 'Sí' : 'No') : '-';
  }
}
